import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";

import MDButton from "components/MDButton";

function ValueVisibilityToggleButton({ valuesHidden, onToggle, scopeLabel }) {
  const actionTitle = valuesHidden ? "Mostrar valores" : "Ocultar valores";

  return (
    <MDButton
      variant="gradient"
      color="info"
      size="small"
      onClick={onToggle}
      aria-pressed={valuesHidden}
      title={`${actionTitle}${scopeLabel ? ` ${scopeLabel}` : ""}`}
      sx={{
        minWidth: { xs: 40, sm: "auto" },
        px: { xs: 1, sm: 2 },
        whiteSpace: "nowrap",
      }}
    >
      <Icon>{valuesHidden ? "visibility" : "visibility_off"}</Icon>
    </MDButton>
  );
}

ValueVisibilityToggleButton.defaultProps = {
  scopeLabel: "",
};

ValueVisibilityToggleButton.propTypes = {
  valuesHidden: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  scopeLabel: PropTypes.string,
};

export default ValueVisibilityToggleButton;
